
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect } from 'react';
import Head from 'next/head';
import type { NextPage } from 'next';
import TopcoPageHistory from '@src/lib/utils/topcoPageHistory';
import dynamic from 'next/dynamic';
import { isRefererCheck } from '@src/lib/utils/utils';
import { useRouter } from 'next/router';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import SeoComponent from '@src/view/common/seo/SeoCompnent';
import { getAspCharacters } from '@src/server/chat';
import { openChatPromoModal } from '@src/view/modal/chatPromo/ChatPromoModal';
import { useRecoilValue } from 'recoil';
import { globalProcessState } from '@src/atom/globalProcess';
import Cookies from 'js-cookie';

const HomeComponent = dynamic<any>(
  () => import('@src/view/components/home/HomeComponent'),
  { ssr: false },
);

const Home: NextPage = (props: any) => {
  const { isReferer, characters } = props;
  const router = useRouter();

  useEffect(() => {
    if (!isReferer) {
      TopcoPageHistory.getInstance().clear();
      TopcoPageHistory.getInstance().setter({
        path: router.asPath,
        scroll: window.scrollY,
        fix: '',
      });
    }
  }, [isReferer]);

  // 채팅 프로모 모달 — 채팅 진입 이력이 없는(hasChatHistory === false) 유저에게만 메인에서 노출(유입 유도).
  // globalProcessContext 가 로드된 뒤(null 아님) + false 일 때만 → 로딩 전 오노출 방지.
  const globalProcessContext = useRecoilValue(globalProcessState);
  useEffect(() => {
    // 채팅사이트에서 넘어온 경우(action=login + redirectUrl에 chat.global.toptoon.com) → 프로모 모달 안 띄움
    const { action, redirectUrl } = router.query;
    const isChatRedirect =
      action === 'login' &&
      `${redirectUrl ?? ''}`.includes('chat.global.toptoon.com');
    if (isChatRedirect) return;

    if (globalProcessContext && !globalProcessContext.hasChatHistory) {
      // 하루에 한 번만 노출 (쿠키) — 오늘 이미 떴으면 스킵
      const COOKIE_KEY = 'chatPromoShown';
      if (Cookies.get(COOKIE_KEY)) return;
      openChatPromoModal();
      // 다음 자정까지 만료 → 하루 1회
      const now = new Date();
      const nextMidnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
      );
      Cookies.set(COOKIE_KEY, '1', { expires: nextMidnight });
    }
  }, [globalProcessContext]);

  return (
    <>
      <Head>
        <link rel="manifest" href="/favicon/manifest.json" />
      </Head>
      <SeoComponent.Main />
      <HomeComponent characters={characters} />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  // 채팅사이트 handoff: /?action=login&targetUrl=/payment?userKey=... 로 들어오면
  //   payment 로 서버 리다이렉트 → 거기서 userKey 로 자동로그인(revokeToken) 처리.
  //   (미들웨어는 '/' 를 안 타므로 여기서 넘겨줘야 함)
  const action = context.query?.action;
  const targetUrl = context.query?.targetUrl
    ? `${context.query.targetUrl}`
    : '';
  // ⚠️ 실제 userKey= 파라미터가 있을 때만 리다이렉트 (미들웨어의 searchParams.get('userKey')와 동일 기준).
  //   substring(includes)로 하면 깨진 URL(userKeyXXX, '=' 없음)도 매칭돼서 홈↔payment 무한루프 발생.
  const targetHasUserKey = new URLSearchParams(
    targetUrl.split('?')[1] ?? '',
  ).has('userKey');
  if (
    action === 'login' &&
    targetUrl.startsWith('/payment') &&
    targetHasUserKey
  ) {
    return { redirect: { destination: targetUrl, permanent: false } };
  }

  const isReferer: boolean = isRefererCheck(context);

  // 외부 채팅사이트 유입 시 심어진 chat_pid 쿠키를 파트너코드(p_id)처럼 처리.
  // URL 에 p_id 가 있으면 그게 우선(setterSSR 내부 p_id || pid), 없으면 chat_pid 사용.
  await TopcoPartner.setterSSR(context, context.req.cookies?.chat_pid);

  // ToptoonChat 캐릭터 목록 (Server-to-Server, SSR에서만 호출)
  const characterResult = await getAspCharacters();
  const characters =
    characterResult?.success && Array.isArray(characterResult.data)
      ? characterResult.data
      : [];

  return {
    props: {
      isReferer,
      characters,
    },
  };
}

export default Home;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  